export default __webpack_public_path__ + "static/media/hobby.d05dcb0d.png";